import { openApi } from '@/api/request'

export default {
  getCampaignQuestions (requestData) {
    const url = `/Rccl.OpenApi/CampaignSurvey/GetCampaignQuestions`
    return openApi.post(url, requestData)
  },
  submitCampaignAnswer (requestData) {
    const url = `/Rccl.OpenApi/CampaignSurvey/SubmitCampaignAnswer`
    console.log(requestData)
    return openApi.post(url, requestData)
  },
  checkSubmittedSurveyByUser () {
    const url = `/Rccl.OpenApi/CampaignSurvey/CheckSubmittedSurveyByUser`
    return openApi.post(url)
  }
}
